import { Controller, useFormContext } from 'react-hook-form';
import ReactSelect, { ReactSelectProps } from '../../../Form/ReactSelect';
import { HookInputBaseProps } from '../../types';

export interface HookReactMultiSelectProps
  extends ReactSelectProps,
    HookInputBaseProps {
  componentClassName?: string;
}

export const HookReactMultiSelect = (props: HookReactMultiSelectProps) => {
  const { name = '', required, validate, id, ...rest } = props;
  const { control } = useFormContext();
  const idOrName = id || name;
  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={control}
      render={({ field, fieldState: { error, isTouched } }) => (
        <>
          <ReactSelect
            {...rest}
            {...field}
            id={idOrName}
            isMulti
            closeMenuOnSelect={false}
            error={isTouched ? error?.message : ''}
          />
        </>
      )}
    />
  );
};

export const HookReactSingleSelect = (props: HookReactMultiSelectProps) => {
  const { name = '', required, validate, componentClassName, ...rest } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={control}
      render={({ field, fieldState: { error, isTouched } }) => (
        <div className={`${componentClassName}`}>
          <ReactSelect {...rest} {...field} error={error?.message} />
        </div>
      )}
    />
  );
};
